class SpecialRequirement {
  constructor() {
    this.specialRequirementInputs = document.querySelectorAll('.js-special-requirement');
    
    if (this.specialRequirementInputs.length > 0) {
      this.init();
    }
  }

  init() {
    try {
      // Add event listeners to all special requirement inputs
      this.specialRequirementInputs.forEach(input => {
        if (input) {
          input.addEventListener('input', () => this.handleInputChange());
        }
      });
    } catch (error) {
      console.error('Error initializing SpecialRequirement:', error);
    }
  }

  handleInputChange() {
    try {
      // This is just for any potential future functionality
      // We're not modifying the button state anymore
    } catch (error) {
      console.error('Error handling input change:', error);
    }
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SpecialRequirement();
  });
} else {
  new SpecialRequirement();
} 